import { render } from "./SearchResult.vue?vue&type=template&id=6f07907e"
import script from "./SearchResult.vue?vue&type=script&lang=js"
export * from "./SearchResult.vue?vue&type=script&lang=js"

import "./SearchResult.vue?vue&type=style&index=0&id=6f07907e&lang=css"

import exportComponent from "/Users/jeongyunl/Documents/GitHub/datamap-search/vue-for-django/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__